import { StatusTag } from "@/molecules/StatusTag"

import styles from "./RulesCell.module.scss"

import type { Record } from "@/pages/GovernancePage/applications/policies/getDemoData.types"

export const RulesCell = (_: unknown, record: Record) => {
  if (record.type !== "scope" && record.type !== "agent") return null

  const { allowed, notAllowed } = record

  return (
    <div className={styles.container}>
      {allowed.length > 0 && (
        <StatusTag status="success" text={`${allowed.length} allows`} />
      )}
      {notAllowed.length > 0 && (
        <StatusTag status="failed" text={`${notAllowed.length} don't allow`} />
      )}
    </div>
  )
}
